module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.26964",
      "conversations-internal-schema": "static-1.12944",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8038",
      "hubspot-url-utils": "static-1.4155",
      "HubStyleTokens": "static-2.11496",
      "I18n": "static-7.1631",
      "jasmine-runner": "static-1.6488",
      "quartz": "static-1.7062",
      "react": "static-7.186",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.487",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6161",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "raven-hubspot": "static-1.6232",
      "bend-plugin-trellis-migration": "static-1.3417",
      "moment": "static-3.26",
      "customer-data-email": "static-1.18074",
      "cv-backend-services": "static-1.1553",
      "hub-http": "static-1.6246",
      "immutable": "static-2.80",
      "immutable-less": "static-1.4677",
      "quartz-config": "static-1.840",
      "quartz-core": "static-1.6281",
      "transmute": "static-2.85",
      "HeadJS": "static-2.764",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7983",
      "framer-motion": "static-1.72",
      "hs-test-utils-bend-plugin": "static-1.3149",
      "msw": "static-1.39",
      "react-redux": "static-7.72",
      "redux": "static-4.16",
      "testing-library": "static-1.152",
      "foundations-theming": "static-1.4444",
      "i18n-data": "static-1.221",
      "metrics-js": "static-1.9667",
      "moment-timezone": "static-5.83",
      "react-utils": "static-2.5362",
      "jasmine": "static-4.4351",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.66",
      "styled-components": "static-2.90",
      "UIComponents": "static-3.8442",
      "visitor-ui-component-library-icons": "static-1.5972",
      "bender-build-tools": "static-1.3215",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4676",
      "apollo-stack-hubspot": "static-3.86",
      "classnames": "static-2.10",
      "cssUtils": "static-1.798",
      "customer-data-objects": "static-1.7697",
      "customer-data-ui-utilities": "static-1.9850",
      "data-fetching-client": "static-1.9691",
      "FileManagerCore": "static-1.39188",
      "FileManagerLib": "static-1.39329",
      "foundations-assets": "static-1.4892",
      "graphql": "static-1.82",
      "hs-promise-utils": "static-1.5615",
      "hubspot-apollo-client": "static-1.4903",
      "icons": "static-2.650",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.105",
      "react-virtualized": "static-2.99",
      "rpc-client-utils": "static-1.4676",
      "salesImages": "static-1.525",
      "timezone-utils": "static-2.5269",
      "ui-gdpr-components": "static-1.10374",
      "ts-schema": "static-1.4098",
      "hs-locale-management": "static-1.98",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.137",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.838",
      "hubspotter-http": "static-1.4669",
      "mobile-manifest-mixins": "static-1.538",
      "module-federation": "static-1.23",
      "quartz-auth": "static-1.737",
      "quartz-head": "static-1.727",
      "quartz-i18n": "static-1.737",
      "quartz-routing": "static-1.492",
      "quartz-test": "static-1.737",
      "quartz-tracking": "static-1.441",
      "quick-fetch": "static-1.3934",
      "react-rhumb": "static-1.16695",
      "ui-fonts": "static-1.758",
      "usage-tracker-container": "static-1.7362",
      "usage-tracker-core": "static-1.7222",
      "bend-plugin-foundations-components": "static-1.4252",
      "floating-ui": "static-1.56",
      "foundations-theming-specialty": "static-1.2160",
      "hs-story-utils": "static-1.9448",
      "react-create-root-preference": "static-1.29",
      "tanstack-table": "static-1.55",
      "trellis-assets": "static-1.2023",
      "ui-images": "static-2.1160",
      "bend-plugin-foundations-theming": "static-1.2927",
      "foundations-theming-base": "static-1.3429",
      "stylex": "static-1.33",
      "HubStyle": "static-2.11803",
      "sassPrefix": "static-1.156",
      "inbound-db-properties-service-client": "static-1.3864",
      "property-translator": "static-1.5423",
      "react-dnd-compat": "static-1.4639",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.9035",
      "audio-components": "static-1.5951",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29339",
      "file-manager-components": "static-1.23689",
      "FileManagerImages": "static-1.36840",
      "foundations-components-legacy": "static-1.1008",
      "immerable": "static-1.4178",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.9007",
      "urlinator": "static-1.4561",
      "video-components": "static-1.13357",
      "video-data-lib": "static-1.35012",
      "video-embed": "static-1.35846",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.362",
      "bend-plugin-chirp-manifest": "static-1.86",
      "chirp-fetch": "static-1.1912",
      "hub-http-shared-msw-handlers": "static-1.10023",
      "hubspotter-http-shared-msw-handlers": "static-1.10021",
      "usage-tracker-session-replay": "static-1.5058",
      "web-vitals": "static-1.6",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.21412",
      "ContentUtils": "static-1.68438",
      "copilot-toolkit": "static-1.11197",
      "customer-data-objects-ui-components": "static-1.13053",
      "sanitize": "static-1.4500",
      "sanitize-text": "static-1.8167",
      "content-assistance-lib": "static-1.7788",
      "usage-tracker": "static-1.7372",
      "ui-addon-iframeable": "static-1.9084",
      "video-components-external": "static-1.11354",
      "unified-auth-core-lib": "static-1.803",
      "content-icons-ui": "static-1.2233",
      "social-insights-client-types": "static-1.22183",
      "SharedI18nStrings": "static-1.182",
      "outpost": "static-1.4203",
      "amplitude-session-replay-browser": "static-1.60",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4836",
      "integrations-lib": "static-1.16235",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5567",
      "magpie-types": "static-1.5027",
      "simple-logging-lib": "static-1.3075",
      "atom": "static-1.5097",
      "avatar-components": "static-1.2522",
      "reference-resolvers": "static-1.8195",
      "superstore": "static-1.4785",
      "ui-addon-video-player": "static-1.8727",
      "ui-coaching-tips": "static-1.28630",
      "navigation-messaging": "static-1.7437",
      "content-media-composition-data-lib": "static-1.12397",
      "content-media-compositions": "static-2.16404",
      "idb-keyval": "static-1.44",
      "media-bridge-lib": "static-1.18967",
      "fsm": "static-1.3755",
      "flux-actions": "static-1.341",
      "frontend-preferences-client": "static-1.7951",
      "integrations-error-boundary-lib": "static-1.13650",
      "integrations-tracking-lib": "static-1.5626",
      "laboratory-lib": "static-3.7180",
      "native-integrations-shared-strings": "static-1.7806",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10390",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11173",
      "ui-shepherd-react": "static-3.10194",
      "unified-auth": "static-1.521",
      "reactive-lib": "static-1.747",
      "growth-onboarding-feedback-components": "static-1.6604",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.3037",
      "foundations-components-test-utils": "static-1.5466",
      "google-sheets-integration-lib": "static-1.312",
      "microsoft-drive-integration-lib": "static-1.444",
      "slack-ui-library": "static-1.10416",
      "react-dlb": "static-1.79",
      "crm-record-cards-service-types": "static-1.3615",
      "framework-data-schema-resolvers": "static-1.6909",
      "location-customization-utils-lib": "static-1.9336",
      "batch-promise": "static-1.1566",
      "conditional-properties-service-client": "static-1.3815",
      "crm-pipelines-api-client-types": "static-1.4157",
      "fdsr-migration-layer": "static-1.28",
      "framework-builder-read-service-client": "static-1.4023",
      "framework-data-schema-quick-fetch": "static-1.6814",
      "inbound-db-meta-service-client": "static-1.3604",
      "multi-currency-client-types": "static-1.3709",
      "persist-promise": "static-1.3723"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.26964",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12944",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8038",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4155",
      "HubStyleTokens": "/HubStyleTokens/static-2.11496",
      "I18n": "/I18n/static-7.1631",
      "jasmine-runner": "/jasmine-runner/static-1.6488",
      "quartz": "/quartz/static-1.7062",
      "react": "/react/static-7.186",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.487",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6161",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3417",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.18074",
      "cv-backend-services": "/cv-backend-services/static-1.1553",
      "hub-http": "/hub-http/static-1.6246",
      "immutable": "/immutable/static-2.80",
      "immutable-less": "/immutable-less/static-1.4677",
      "quartz-config": "/quartz-config/static-1.840",
      "quartz-core": "/quartz-core/static-1.6281",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.764",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7983",
      "framer-motion": "/framer-motion/static-1.72",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3149",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.72",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.152",
      "foundations-theming": "/foundations-theming/static-1.4444",
      "i18n-data": "/i18n-data/static-1.221",
      "metrics-js": "/metrics-js/static-1.9667",
      "moment-timezone": "/moment-timezone/static-5.83",
      "react-utils": "/react-utils/static-2.5362",
      "jasmine": "/jasmine/static-4.4351",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.66",
      "styled-components": "/styled-components/static-2.90",
      "UIComponents": "/UIComponents/static-3.8442",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5972",
      "bender-build-tools": "/bender-build-tools/static-1.3215",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4676",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.798",
      "customer-data-objects": "/customer-data-objects/static-1.7697",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9850",
      "data-fetching-client": "/data-fetching-client/static-1.9691",
      "FileManagerCore": "/FileManagerCore/static-1.39188",
      "FileManagerLib": "/FileManagerLib/static-1.39329",
      "foundations-assets": "/foundations-assets/static-1.4892",
      "graphql": "/graphql/static-1.82",
      "hs-promise-utils": "/hs-promise-utils/static-1.5615",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4903",
      "icons": "/icons/static-2.650",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.105",
      "react-virtualized": "/react-virtualized/static-2.99",
      "rpc-client-utils": "/rpc-client-utils/static-1.4676",
      "salesImages": "/salesImages/static-1.525",
      "timezone-utils": "/timezone-utils/static-2.5269",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10374",
      "ts-schema": "/ts-schema/static-1.4098",
      "hs-locale-management": "/hs-locale-management/static-1.98",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.137",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.838",
      "hubspotter-http": "/hubspotter-http/static-1.4669",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
      "module-federation": "/module-federation/static-1.23",
      "quartz-auth": "/quartz-auth/static-1.737",
      "quartz-head": "/quartz-head/static-1.727",
      "quartz-i18n": "/quartz-i18n/static-1.737",
      "quartz-routing": "/quartz-routing/static-1.492",
      "quartz-test": "/quartz-test/static-1.737",
      "quartz-tracking": "/quartz-tracking/static-1.441",
      "quick-fetch": "/quick-fetch/static-1.3934",
      "react-rhumb": "/react-rhumb/static-1.16695",
      "ui-fonts": "/ui-fonts/static-1.758",
      "usage-tracker-container": "/usage-tracker-container/static-1.7362",
      "usage-tracker-core": "/usage-tracker-core/static-1.7222",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4252",
      "floating-ui": "/floating-ui/static-1.56",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2160",
      "hs-story-utils": "/hs-story-utils/static-1.9448",
      "react-create-root-preference": "/react-create-root-preference/static-1.29",
      "tanstack-table": "/tanstack-table/static-1.55",
      "trellis-assets": "/trellis-assets/static-1.2023",
      "ui-images": "/ui-images/static-2.1160",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2927",
      "foundations-theming-base": "/foundations-theming-base/static-1.3429",
      "stylex": "/stylex/static-1.33",
      "HubStyle": "/HubStyle/static-2.11803",
      "sassPrefix": "/sassPrefix/static-1.156",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3864",
      "property-translator": "/property-translator/static-1.5423",
      "react-dnd-compat": "/react-dnd-compat/static-1.4639",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9035",
      "audio-components": "/audio-components/static-1.5951",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29339",
      "file-manager-components": "/file-manager-components/static-1.23689",
      "FileManagerImages": "/FileManagerImages/static-1.36840",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1008",
      "immerable": "/immerable/static-1.4178",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.9007",
      "urlinator": "/urlinator/static-1.4561",
      "video-components": "/video-components/static-1.13357",
      "video-data-lib": "/video-data-lib/static-1.35012",
      "video-embed": "/video-embed/static-1.35846",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.362",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.86",
      "chirp-fetch": "/chirp-fetch/static-1.1912",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10023",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10021",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5058",
      "web-vitals": "/web-vitals/static-1.6",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.21412",
      "ContentUtils": "/ContentUtils/static-1.68438",
      "copilot-toolkit": "/copilot-toolkit/static-1.11197",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13053",
      "sanitize": "/sanitize/static-1.4500",
      "sanitize-text": "/sanitize-text/static-1.8167",
      "content-assistance-lib": "/content-assistance-lib/static-1.7788",
      "usage-tracker": "/usage-tracker/static-1.7372",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9084",
      "video-components-external": "/video-components-external/static-1.11354",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.803",
      "content-icons-ui": "/content-icons-ui/static-1.2233",
      "social-insights-client-types": "/social-insights-client-types/static-1.22183",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "outpost": "/outpost/static-1.4203",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4836",
      "integrations-lib": "/integrations-lib/static-1.16235",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5567",
      "magpie-types": "/magpie-types/static-1.5027",
      "simple-logging-lib": "/simple-logging-lib/static-1.3075",
      "atom": "/atom/static-1.5097",
      "avatar-components": "/avatar-components/static-1.2522",
      "reference-resolvers": "/reference-resolvers/static-1.8195",
      "superstore": "/superstore/static-1.4785",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8727",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28630",
      "navigation-messaging": "/navigation-messaging/static-1.7437",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12397",
      "content-media-compositions": "/content-media-compositions/static-2.16404",
      "idb-keyval": "/idb-keyval/static-1.44",
      "media-bridge-lib": "/media-bridge-lib/static-1.18967",
      "fsm": "/fsm/static-1.3755",
      "flux-actions": "/flux-actions/static-1.341",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7951",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13650",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5626",
      "laboratory-lib": "/laboratory-lib/static-3.7180",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7806",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10390",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11173",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10194",
      "unified-auth": "/unified-auth/static-1.521",
      "reactive-lib": "/reactive-lib/static-1.747",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6604",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3037",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5466",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.312",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.444",
      "slack-ui-library": "/slack-ui-library/static-1.10416",
      "react-dlb": "/react-dlb/static-1.79",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6909",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9336",
      "batch-promise": "/batch-promise/static-1.1566",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3815",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4157",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.28",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4023",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6814",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3604",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3709",
      "persist-promise": "/persist-promise/static-1.3723"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.26964",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};